/**
 * Elements with [data-countdown-to] show HH:MM:SS until ISO instant; reload when elapsed if data-reload !== "false".
 */
(function () {
  function createSeenSet() {
    if (typeof WeakSet === 'function') return new WeakSet();
    var s = new Set();
    return {
      has: function (el) { return s.has(el); },
      add: function (el) { s.add(el); },
    };
  }

  var started = createSeenSet();

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function bind(el) {
    if (started.has(el)) return;
    started.add(el);
    var iso = el.getAttribute('data-countdown-to');
    if (!iso) return;
    var endMs = new Date(iso).getTime();
    if (isNaN(endMs)) return;

    function upd() {
      var ms = endMs - Date.now();
      if (ms <= 0) {
        el.textContent = '00:00:00';
        if (el.getAttribute('data-reload') !== 'false') {
          window.location.reload();
        }
        return;
      }
      var s = Math.floor(ms / 1000);
      var h = Math.floor(s / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      el.textContent = pad(h) + ':' + pad(m) + ':' + pad(sec);
    }

    upd();
    setInterval(upd, 1000);
  }

  function run() {
    document.querySelectorAll('[data-countdown-to]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
